import { mutateIntegrationStatus } from '../mutations/mutateIntegrationStatus';
import { mutateOrganizationSettings } from '../mutations/mutateOrganizationSettings';
import { organizationSettingsAPI } from 'api/organizationSettings/endpoints';
import { RollbarIntegrationPayload } from 'api/organizationSettings/models';

export const addRollbarIntegration = async (
  formData: RollbarIntegrationPayload,
) => {
  await organizationSettingsAPI.addRollbarIntegration(formData);
  await mutateOrganizationSettings();
  await mutateIntegrationStatus();
};
